module.exports = __webpack_public_path__ + "static/media/review_2.df8abb4a.jpg";